module.exports = __webpack_public_path__ + "img/c.8ac1db17.png";